import { ShopifyPages } from "./domain/shopify-pages.enum.ts"; 
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'intersection-observer';
import "reflect-metadata";
import 'lazysizes';
import './index.scss';
import './global.scss';
import './components.scss';
import './spacing.scss';
import './pages/all.ts';

export default (async () => {
  console.log("Loaded");

})();



